import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { MainLayout } from '@/core/components';
import { AuthGuard } from '@/core/middleware';
import { Suspense, lazy } from 'react';
import { LoadingGlobal } from '@/core/components';

const SubscriptionPlanPage = lazy(() => import('./pages/SubscriptionPlanPage'));
const SubscriptionDetailsPage = lazy(
  () => import('./pages/SubscriptionDetailsPage')
);
const InvoiceHistoryPage = lazy(() => import('./pages/InvoiceHistoryPage'));

export const subscriptionRoutes: RouteObject[] = [
  {
    path: '/subscription',
    element: (
      <AuthGuard>
        <MainLayout>
          <Outlet></Outlet>
        </MainLayout>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Navigate to='plan' replace />,
      },
      {
        path: 'plan',
        element: (
          <Suspense fallback={<LoadingGlobal />}>
            <SubscriptionPlanPage />
          </Suspense>
        ),
      },
      {
        path: 'details',
        element: (
          <Suspense fallback={<LoadingGlobal />}>
            <SubscriptionDetailsPage />
          </Suspense>
        ),
      },
      {
        path: 'invoice-history',
        element: (
          <Suspense fallback={<LoadingGlobal />}>
            <InvoiceHistoryPage />
          </Suspense>
        ),
      },
    ],
  },
];
